import React from 'react';
import { useSelector } from 'react-redux';

import { RawToggle as Toggle } from '@swf/components/Inputs/Toggle';
import Translation from '@swf/components/Translation/Translation';
import useTrackers from '@swf/core/hooks/useTrackers';
import useTrackingLabel from '@swf/core/hooks/useTrackingLabel';
import { select } from '@swf/core/store';
import useAutoAcceptPriceChanges from '@swf/sports/hooks/useAutoAcceptPriceChanges';

import { TXTWCL_Accept_all_price_changes } from './AutoAcceptPriceChangesToggle.messages.json';
import styles from './AutoAcceptPriceChangesToggle.scss';

const AutoAcceptPriceChangesToggle: React.FC = () => {
  const hasAutoAcceptEnabled = useSelector(select.account.hasAutoAcceptEnabled);
  const isClientAuthenticated = useSelector(select.session.isClientAuthenticated);
  const { setAutoAcceptPriceChanges } = useAutoAcceptPriceChanges();
  const { inputFilled } = useTrackers();
  const autoAcceptTrackingLabel = useTrackingLabel(TXTWCL_Accept_all_price_changes);

  const id = 'bet-slip-auto-accept-price-changes';

  if (isClientAuthenticated) {
    return (
      <div data-testid={id}>
        <Toggle
          className={styles.toggle}
          align="right"
          aria-checked={hasAutoAcceptEnabled}
          checked={hasAutoAcceptEnabled}
          id={id}
          label={<Translation {...TXTWCL_Accept_all_price_changes} />}
          onChange={async () => {
            await setAutoAcceptPriceChanges({ autoAcceptPriceChanges: !hasAutoAcceptEnabled });
            inputFilled({
              fieldName: autoAcceptTrackingLabel,
              fieldType: 'switch',
              boolInput: !hasAutoAcceptEnabled
            });
          }}
          onOffToggle
          type="switch"
          variant="secondary"
        />
      </div>
    );
  }

  return null;
};

export default AutoAcceptPriceChangesToggle;
